import React, { Fragment, useEffect, useState } from "react";
import { axios } from "../../../../../Global";
import { useDispatch, useSelector } from "react-redux";
import { setAppError } from "../../../../../store/userSlice";
import { BiEdit } from "react-icons/bi";
import { checkAccessFn } from "../../../../../utils/checkAccess";
import { compareObjects } from "../../../../../utils/EditChangeValidate";
import { getFormattedDate } from "../../../../../utils/functions";

const ContractViewFirstTable = ({
  contractDetails,
  contractId,
  updateComponent,
  updateValue,
}) => {
  console.log(
    ".......Data to be seen here ......",
    contractDetails.contract.visa_sec_deposit_status
  );
  const dispatch = useDispatch();
  const prevState = contractDetails?.contract;
  const [submitting, setSubmitting] = useState(false);

  const [allowEdit, setAllowEdit] = useState(false);
  const _arr = [
    {
      title: "STATUS",
      value: contractDetails?.contract?.status,
      editable: true,
      options: ["ACTIVE", "INACTIVE"],
    },
    {
      title: "QUOTATION TYPE",
      value: contractDetails?.contract?.quotation_type?.name,
      editable: false,
      type: "text",
    },
    {
      title: "SOURCE",
      value: contractDetails.source?.name,
      editable: false,
      type: "text",
    },
    {
      title: "SECTOR",
      value: contractDetails?.sector?.name,
      editable: false,
      type: "text",
    },
    {
      title: "START DATE",
      value: contractDetails?.contract?.start_date,
      editable: true,
      type: "date",
      changed: false,
    },
    {
      title: "END DATE",
      value: contractDetails?.contract?.end_date,
      editable: true,
      type: "date",
      changed: false,
    },
    {
      title: "CONTRACT TENURE",
      value: contractDetails?.contract?.tenure,
      editable: true,
      options: Array.from({ length: 24 }, (_, i) => `${i + 1}`),
    },
    {
      title: "CONTRACT STATUS",
      value: contractDetails?.contract?.contract_status,
      editable:
        contractDetails?.contract_file?.filter(
          (file) => file?.type == "CONTRACT FILE"
        )?.length > 0
          ? true
          : false,
      options: ["SIGNED", "NOT SIGNED"],
    },
    {
      title: "ANNEXURE STATUS",
      value: contractDetails?.contract?.annexure_status,
      editable:
        contractDetails?.contract_file?.filter(
          (file) => file?.type == "ANNEXURE FILE"
        )?.length > 0
          ? true
          : false,
      options: ["SIGNED", "NOT SIGNED"],
    },
    {
      title: "COC ATTESTATION",
      value: contractDetails?.contract?.coc_attestation,
      editable:
        contractDetails?.contract_file?.filter(
          (file) => file?.type == "COC FILE"
        )?.length > 0
          ? true
          : false,
      options: ["YES", "NO", "FIRST PARTY DONE", "BOTH PARTIES DONE", "NA"],
    },
    {
      title: "ORIGINAL RECEIVED",
      value: contractDetails?.contract?.orginal_received,
      editable:
        contractDetails?.contract_file?.filter(
          (file) => file?.type == "ORGINAL DOC"
        )?.length > 0
          ? true
          : false,
      options: ["YES", "NO"],
    },
    {
      title: "INVOICE FOR VISA COST",
      value: contractDetails?.contract?.invoice_for_visa_cost,
      editable:
        contractDetails.contract.visa_sec_deposit_status === "NO"
          ? true
          : false,
      // type: "special",
      sub: "invoice",
      options: ["YES", "NO"],
      hide: contractDetails?.contract?.quotation_type?.name != "Cost Plus",
      invoice_status: {
        title: "INVOICE FOR VISA COST STATUS",
        value: contractDetails?.contract?.invoice_for_visa_cost_status,
        editable: true,
        // value: "PENDING",
        options: [
          "PENDING",
          // "APPLICABLE",
          // "NOT APPLICABLE",
          "INVOICE RAISED FULL",
          "INVOICE RAISED PARTIALLY",
          "PARTIAL PAYMENT RECEIVED",
          "FULL PAYMENT RECEIVED",
          // "INVOICE ON-ARRIVAL",
          "CLIENT REFUSE TO PAY",
        ],
      },
      invoice_type: {
        title1: "ON-ARRIVAL",
        title2: "IMMEDIATE",
        value: contractDetails?.contract?.invoice_for_visa_cost_type,
        editable: true,
        options: ["ON-ARRIVAL", "IMMEDIATE"],
      },
    },
    {
      title: "INVOICE FOR SECURITY DEPOSIT",
      value: contractDetails?.contract?.invoice_for_security_deposit,
      editable:
        contractDetails.contract.visa_sec_deposit_status === "NO"
          ? true
          : false,
      options: ["YES", "NO"],
      // type: "special",
      sub: "invoice",
      invoice_status: {
        title: "INVOICE FOR SECURITY DEPOSIT STATUS",
        value: contractDetails?.contract?.invoice_for_security_deposit_status,
        editable: true,
        options: [
          "PENDING",
          // "APPLICABLE",
          // "NOT APPLICABLE",
          "INVOICE RAISED FULL",
          "INVOICE RAISED PARTIALLY",
          "PARTIAL PAYMENT RECEIVED",
          "FULL PAYMENT RECEIVED",
          // "INVOICE ON-ARRIVAL",
          "CLIENT REFUSE TO PAY",
        ],
      },
      invoice_type: {
        title1: "ON-ARRIVAL",
        title2: "IMMEDIATE",
        value: contractDetails?.contract?.invoice_for_security_deposit_type,
        editable: true,
        options: ["ON-ARRIVAL", "IMMEDIATE"],
      },
    },
    {
      title: "COMMENTS BY FINANCE",
      editable: false,
      type: "textarea",
      value: contractDetails?.contract?.finance_comments,
    },
    {
      title: "COMMENTS FOR FINANCE",
      editable: true,
      type: "textarea",
      value: contractDetails?.contract?.comments_for_finance,
    },
  ];

  const copiedArray = JSON.parse(JSON.stringify(_arr));
  const [arr, setArr] = useState([...copiedArray]);

  useEffect(() => {
    const _copiedArray = JSON.parse(JSON.stringify(_arr));
    setArr([..._copiedArray]);
  }, [contractDetails]);

  const reverseDate = (date) => {
    return String(date).split("-").reverse().join("-");
  };

  const [editField, setEditField] = useState(false);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (arr?.length <= 0) return;
    const body = getBody(contractDetails, arr);
    const isSame = compareObjects(prevState, body);
    if (!isSame) setAllowEdit(true);
    else setAllowEdit(false);
  }, [arr]);

  const submitHandler = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const body = getBody(contractDetails, arr);

    try {
      const response = await axios.put(
        `/dashboard/contract/${contractId}`,
        body,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.status === 200) {
        setEditField(false);
        updateComponent((p) => !p);
        dispatch(
          setAppError({
            msg: response.data.message,
            color: "success",
          })
        );
        setAllowEdit(false);
      }
    } catch (err) {
      if (err.response?.status === 401) {
        if (err.response?.data?.validation_error) {
          for (let i in err.response?.data?.validation_error) {
            dispatch(
              setAppError({
                msg:
                  err.response?.data?.validation_error[i] ||
                  "Something went wrong!",
              })
            );
          }
        }
      } else {
        dispatch(
          setAppError({
            msg: err?.response?.data?.message,
          })
        );
      }
    } finally {
      setSubmitting(false);
    }
  };

  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

  return (
    <form
      className="bg-slate-50 shadow-md rounded-lg my-4 min-h-[50vh] p-5 px-2 flex flex-col items-center"
      onSubmit={submitHandler}
    >
      {!editField && checkAccess("Contract", "contract-edit") && (
        <div className="flex gap-3 justify-end w-full">
          <button
            className="bg-blue p-2 w-24 text-white rounded-md flex gap-3 justify-center items-center"
            onClick={() => setEditField((p) => !p)}
          >
            Edit
            <BiEdit size={"1.3rem"} />
          </button>
        </div>
      )}
      <div className="grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-x-10 md:gap-y-10 gap-y-4 w-11/12">
        {arr?.map((elem, i) => {
          return (
            <Fragment key={elem?.title}>
              {
                i == "11" && <div className="hidden xl:flex"></div> //to bring the Invoice For security Deposit
              }
              <div
                key={elem.title}
                className={`p-3 flex flex-col gap-2 ${
                  elem.hide ? "hidden" : "flex"
                }`}
              >
                {elem?.type === "checkbox" ? (
                  <div className="flex flex-col gap-3">
                    <h2 className="font-semibold">{elem.title}</h2>
                    <div className="flex gap-2 justify-between">
                      <div className="form-control">
                        <label className="label cursor-pointer gap-2">
                          <span className="label-text">Yes</span>
                          <input
                            type="radio"
                            name={elem?.title}
                            className="radio "
                            disabled={
                              !editField ||
                              contractDetails.contract
                                .visa_sec_deposit_status == "YES"
                            }
                            onClick={(e) => {
                              const updatedArr = [...arr];
                              const index = updatedArr.findIndex(
                                (item) => item.title === elem.title
                              ); // Find the index of the element with the same title
                              if (index !== -1) {
                                updatedArr[index] = {
                                  ...updatedArr[index],
                                  value: "YES",
                                }; // Update the value based on checkbox status
                                setArr([...updatedArr]); // Update the state with the modified array
                              }
                            }}
                            checked={elem?.value === "YES"}
                          />
                        </label>
                      </div>
                      <div className="form-control">
                        <label className="label cursor-pointer gap-2">
                          <span className="label-text">No</span>
                          <input
                            type="radio"
                            name={elem?.title}
                            className="radio"
                            disabled={!editField}
                            onClick={(e) => {
                              const updatedArr = [...arr];
                              const index = updatedArr.findIndex(
                                (item) => item.title === elem.title
                              ); // Find the index of the element with the same title
                              if (index !== -1) {
                                updatedArr[index] = {
                                  ...updatedArr[index],
                                  value: "NO",
                                }; // Update the value based on checkbox status
                                setArr([...updatedArr]); // Update the state with the modified array
                              }
                            }}
                            checked={elem?.value === "NO"}
                          />
                        </label>
                      </div>
                    </div>
                  </div>
                ) : (
                  <h2 className="font-semibold ">{elem.title}</h2>
                )}

                {elem.type ? (
                  <>
                    {elem?.type === "textarea" ? (
                      <textarea
                        defaultValue={elem?.value || ""}
                        className={`textarea textarea-bordered `}
                        disabled={elem.editable ? !editField : true}
                        onChange={(e) => {
                          setArr((p) => {
                            const changedValue = p.find(
                              (e) => e.title === elem.title
                            );
                            changedValue.value = e.target.value?.toUpperCase();
                            const changedValueIndex = p.findIndex(
                              (e) => e.title === elem.title
                            );
                            const nonChangedValue = p.filter(
                              (e) => e.title !== elem.title
                            );
                            nonChangedValue.splice(
                              changedValueIndex,
                              0,
                              changedValue
                            );

                            return [...nonChangedValue];
                          });
                        }}
                      />
                    ) : (
                      <>
                        {elem?.type == "date" && (
                          <p
                            type="text"
                            className="input input-sm pl-1 input-bordered"
                            value={getFormattedDate(elem?.value, "mmm")}
                            disabled={elem.editable ? !editField : true}
                            onClick={() => {
                              console.log(editField);
                              if (editField) {
                                document
                                  .getElementById(elem?.title)
                                  ?.showPicker();
                              }
                            }}
                          >
                            {getFormattedDate(elem?.value, "mmm")}
                          </p>
                        )}
                        <input
                          id={elem?.title}
                          type={elem.type}
                          defaultValue={
                            elem.type === "date"
                              ? reverseDate(getFormattedDate(elem?.value))
                              : elem?.value
                          }
                          className={`relative ${
                            elem.type === "textarea"
                              ? "textarea textarea-bordered "
                              : "input input-sm pl-1 input-bordered"
                          } ${
                            elem?.type == "date"
                              ? "w-0 h-0 p-0 m-0 border-none"
                              : ""
                          }`}
                          disabled={elem.editable ? !editField : true}
                          onChange={(e) => {
                            setArr((p) => {
                              const changedValue = p.find(
                                (e) => e.title === elem.title
                              );
                              if (elem.type === "date") {
                                changedValue.value = reverseDate(
                                  e.target.value
                                );
                                changedValue.changed = true;
                              } else if (elem.type === "text") {
                                changedValue.value = e.target.value;
                              } else if (elem.type === "number") {
                                changedValue.value = e.target.value;
                              }
                              const changedValueIndex = p.findIndex(
                                (e) => e.title === elem.title
                              );
                              const nonChangedValue = p.filter(
                                (e) => e.title !== elem.title
                              );
                              nonChangedValue.splice(
                                changedValueIndex,
                                0,
                                changedValue
                              );

                              return [...nonChangedValue];
                            });
                          }}
                        />
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <select
                      type="text"
                      defaultValue={`${elem.value}` || "--"}
                      value={`${elem.value}` || "--"}
                      className="select select-sm pl-1 select-bordered "
                      disabled={
                        elem.editable
                          ? !editField
                          : true ||
                            contractDetails.contract.visa_sec_deposit_status ==
                              "YES"
                      }
                      onChange={(e) => {
                        if (
                          elem?.title == "INVOICE FOR VISA COST" ||
                          elem?.title == "INVOICE FOR SECURITY DEPOSIT"
                        ) {
                          console.log("get here", elem?.title);
                          const updatedArr = [...arr];
                          const index = updatedArr.findIndex(
                            (item) => item.title === elem.title
                          ); // Find the index of the element with the same title
                          if (index !== -1) {
                            updatedArr[index] = {
                              ...updatedArr[index],
                              value: e.target.value,
                            }; // Update the value based on checkbox status
                            setArr([...updatedArr]); // Update the state with the modified array
                          }
                        } else {
                          setArr((p) => {
                            const changedValue = p.find(
                              (e) => e.title === elem.title
                            );
                            changedValue.value = e.target.value;

                            const changedValueIndex = p.findIndex(
                              (e) => e.title === elem.title
                            );
                            const nonChangedValue = p.filter(
                              (e) => e.title !== elem.title
                            );
                            nonChangedValue.splice(
                              changedValueIndex,
                              0,
                              changedValue
                            );

                            return [...nonChangedValue];
                          });
                        }
                      }}
                    >
                      {!elem.type &&
                        elem?.options?.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                    </select>
                    {elem.sub === "invoice" && (
                      <>
                        {elem?.value === "YES" && (
                          <>
                            <select
                              type="text"
                              defaultValue={
                                `${elem.invoice_status?.value}` || "--"
                              }
                              className="select select-sm pl-1 select-bordered"
                              disabled={
                                !editField ||
                                contractDetails.contract
                                  .visa_sec_deposit_status == "YES"
                              }
                              required
                              onChange={(e) => {
                                const selectedValue = e.target?.value;

                                // const updatedArr = [...arr];
                                const updatedArr = JSON.parse(
                                  JSON.stringify(arr)
                                );

                                // Find the index of the element with the same title
                                const index = updatedArr.findIndex(
                                  (item) => item.title === elem.title
                                );

                                if (index !== -1) {
                                  // Update the value in the object
                                  updatedArr[index].invoice_status.value =
                                    selectedValue;

                                  // Update the state with the modified array
                                  setArr([...updatedArr]);
                                }
                              }}
                            >
                              <option value="" hidden>
                                SELECT AN OPTION
                              </option>
                              {elem?.invoice_status?.options?.map(
                                (option, i) => (
                                  <option key={option} value={option}>
                                    {option}
                                  </option>
                                )
                              )}
                            </select>

                            {/*INVOICE TYPE  */}
                            <div className="flex gap-2 flex-col mt-3">
                              <div className="flex gap-2">
                                <input
                                  name={`type${elem.title}`}
                                  type="radio"
                                  className="checkbox disabled:text-blue"
                                  required
                                  disabled={
                                    !editField ||
                                    contractDetails.contract
                                      .visa_sec_deposit_status == "YES"
                                  }
                                  checked={
                                    elem.invoice_type?.value ===
                                    elem?.invoice_type?.title1
                                  }
                                  onChange={(e) => {
                                    const selectedValue =
                                      elem?.invoice_type?.title1;

                                    // Create a copy of the original array
                                    // const updatedArr = [...arr];
                                    const updatedArr = JSON.parse(
                                      JSON.stringify(arr)
                                    );

                                    // Find the index of the element with the same title
                                    const index = updatedArr.findIndex(
                                      (item) => item.title === elem.title
                                    );

                                    if (index !== -1) {
                                      // Update the value in the object
                                      updatedArr[index].invoice_type.value =
                                        selectedValue;

                                      // Update the state with the modified array
                                      setArr([...updatedArr]);
                                    }
                                  }}
                                  defaultChecked={false}
                                />
                                <label>{elem?.invoice_type?.title1}</label>
                              </div>
                              <div className="flex gap-2">
                                <input
                                  name={`type${elem?.title}`}
                                  type="radio"
                                  className="checkbox"
                                  required
                                  disabled={
                                    !editField ||
                                    contractDetails.contract
                                      .visa_sec_deposit_status == "YES"
                                  }
                                  checked={
                                    elem.invoice_type?.value ===
                                    elem?.invoice_type?.title2
                                  }
                                  onChange={(e) => {
                                    const selectedValue =
                                      elem?.invoice_type?.title2;

                                    // Create a copy of the original array
                                    const updatedArr = JSON.parse(
                                      JSON.stringify(arr)
                                    );

                                    // Find the index of the element with the same title
                                    const index = updatedArr.findIndex(
                                      (item) => item.title === elem.title
                                    );

                                    if (index !== -1) {
                                      // Update the value in the object
                                      updatedArr[index].invoice_type.value =
                                        selectedValue;

                                      // Update the state with the modified array
                                      setArr([...updatedArr]);
                                    }
                                  }}
                                  defaultChecked={false}
                                />
                                <label>{elem?.invoice_type?.title2}</label>
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </Fragment>
          );
        })}
      </div>
      {editField && (
        <div className="flex justify-center mt-5 items-center gap-3 w-full">
          <button
            className="rounded-md p-2 max-w-xs w-full m-3 ring-1 ring-slate-300 "
            type="button"
            disabled={submitting}
            onClick={() => {
              setArr([]);
              setTimeout(() => {
                setArr(JSON.parse(JSON.stringify(_arr)));
              }, 0);
              setEditField(false);
            }}
            title={`${!allowEdit ? "No modifications made" : ""}`}
          >
            Cancel
          </button>
          <button
            className="bg-red rounded-md p-2 max-w-xs w-full m-3 text-white disabled:bg-rose-400 disabled:cursor-not-allowed"
            type="submit"
            disabled={!allowEdit || submitting}
          >
            Submit
          </button>
        </div>
      )}
    </form>
  );
};

export default ContractViewFirstTable;

function getBody(contractDetails, arr) {
  const body = {
    client_id: contractDetails?.contract?.client_id,
    company_id: contractDetails?.contract?.company_id,
    sector_id: contractDetails?.contract?.sector_id,
    source_id: contractDetails?.contract?.source_id,
    quotation_type_id: contractDetails?.contract?.quotation_type_id,
    status: arr.find((e) => e.title === "STATUS")?.value,
    start_date: getFormattedDate(
      arr.find((e) => e.title === "START DATE")?.value
    ),
    end_date: getFormattedDate(arr.find((e) => e.title === "END DATE")?.value),
    contract_status: arr.find((e) => e.title === "CONTRACT STATUS")?.value,
    annexure_status: arr.find((e) => e.title === "ANNEXURE STATUS")?.value,
    orginal_received: arr.find((e) => e.title === "ORIGINAL RECEIVED")?.value,
    coc_attestation: arr.find((e) => e.title === "COC ATTESTATION")?.value,
    tenure: arr.find((e) => e.title === "CONTRACT TENURE")?.value,
    finance_comments: arr.find((e) => e.title === "COMMENTS BY FINANCE")?.value,
    comments_for_finance: arr.find((e) => e.title === "COMMENTS FOR FINANCE")
      ?.value,
    invoice_for_visa_cost: arr.find((e) => e.title === "INVOICE FOR VISA COST")
      ?.value,
    invoice_for_security_deposit: arr.find(
      (e) => e.title === "INVOICE FOR SECURITY DEPOSIT"
    )?.value,
  };

  if (body.invoice_for_visa_cost === "YES") {
    body.invoice_for_visa_cost_status = arr.find(
      (e) => e.title === "INVOICE FOR VISA COST"
    )?.invoice_status?.value;
    body.invoice_for_visa_cost_type = arr.find(
      (e) => e.title === "INVOICE FOR VISA COST"
    )?.invoice_type?.value;
  }
  if (body.invoice_for_security_deposit === "YES") {
    body.invoice_for_security_deposit_status = arr.find(
      (e) => e.title === "INVOICE FOR SECURITY DEPOSIT"
    )?.invoice_status?.value;
    body.invoice_for_security_deposit_type = arr.find(
      (e) => e.title === "INVOICE FOR SECURITY DEPOSIT"
    )?.invoice_type?.value;
  }
  return body;
}
